// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/NATS-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  cursor: none;

}

body::-webkit-scrollbar {
  display: none;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* import nats font from public folder */
@font-face {
  font-family: 'NATS';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}

.title-with-sideline {
  font-family: 'NATS';
  font-size: 128px;
  font-weight: 400;
  color: #ffffff;
  line-height: 8rem;
}

.sideline {
  border-radius: 3px;
  height: auto;
}

.sideline.right {
  margin-left: 3rem;
}

.sideline.left {
  margin-right: 3rem;
}

p {
  margin: 0;
  font-family: 'NATS';
  font-size: 22px;
  font-weight: 400;
}

h1 {
  margin: 0;
  display: block;
  margin-block-start: 1rem;
  margin-block-end: 1rem;
  font-weight: 400;
  font-size: 128px;
}

h2 {
  margin: 0;
  display: block;
  margin-block-start: 1rem;
  margin-block-end: 1rem;
  font-weight: 400;
  font-size: 80px;
}

h3 {
  font-family: "NATS";
  margin: 0;
  display: block;
  margin-block-start: 1rem;
  margin-block-end: 1rem;
  font-weight: 400;
  font-size: 80px;
}

.navbar {
  font-family: 'NATS';
  padding-right: 0.2em;
  font-size: 40px;
  font-weight: 400;
  color: #ffffff;
}

.navbar.open {
  height: 100vh;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.navbar::before {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 50%);
  z-index: -1;
  opacity: 0;
  transition: opacity 1.5s ease-in-out;
}

.sticky::before {
  opacity: 1;
  transition: opacity 1.5s ease-in-out;
}

.sticky {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;
}

@keyframes float {
	0% {
		transform: translatey(0px) rotate(-54deg);
	}
	50% {
		transform: translatey(-20px) rotate(-52deg);
	}
	100% {
		transform: translatey(0px) rotate(-54deg);
	}
}

@keyframes cursorAnimation {
  0% {
    transform: scale(1) translate(-50%, -50%);
    opacity: 1;
  }
  50% {
    transform: scale(1.1) translate(-45%, -45%);
    opacity: 0.98;
  }
  100% {
    transform: scale(1) translate(-50%, -50%);
    opacity: 1;
  }
}

.customCursor {
  position: absolute;
  top: 0; /* Center vertically */
  left: 0; /* Center horizontally */
  width: 20px;
  height: 20px;
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.5);
  pointer-events: none;
  z-index: 1;
  transition: background-color 0.5s ease-in-out, width 0.5s ease-in-out;
  transform-origin: center;
  animation: cursorAnimation 2s infinite;
}

.customCursor.flat {
  width: 4px;
  transform-origin: center;
  background-color: white;
  transition: background-color 0.5s ease-in-out, width 0.5s ease-in-out;
}


.spacer {
  height: 400px;
}

.text-spacer {
  padding-top: 13rem;
}

.project-container {
  margin-top:  4rem;
}

@media (max-width: 1199.98px) {
  .spacer {
    height: 50px;
  }
  .text-spacer {
    padding-top: 3rem;
  }

  .project-container {
    margin-top:  0rem;
  }
}

@keyframes cursorAnimation {
  0% {
    transform: scale(1) translate(-50%, -50%);
    opacity: 1;
  }
  50% {
    transform: scale(1.1) translate(-45%, -45%);
    opacity: 0.98;
  }
  100% {
    transform: scale(1) translate(-50%, -50%);
    opacity: 1;
  }
}

.clip-circle {
  clip-path: circle(165px at center);
  transition: clip-path 1s ease-in-out 0.5s, width 1s ease-in-out 1s, height 1s ease-in-out 1s, transform 1s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,YAAY;;AAEd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;aACW;AACb;;AAEA,wCAAwC;AACxC;EACE,mBAAmB;EACnB,+DAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8EAA8E;EAC9E,WAAW;EACX,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,WAAW;EACX,UAAU;AACZ;;AAEA;CACC;EACC,yCAAyC;CAC1C;CACA;EACC,2CAA2C;CAC5C;CACA;EACC,yCAAyC;CAC1C;AACD;;AAEA;EACE;IACE,yCAAyC;IACzC,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,aAAa;EACf;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM,EAAE,sBAAsB;EAC9B,OAAO,EAAE,wBAAwB;EACjC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,UAAU;EACV,qEAAqE;EACrE,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,uBAAuB;EACvB,qEAAqE;AACvE;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,UAAU;EACZ;EACA;IACE,2CAA2C;IAC3C,aAAa;EACf;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA;EACE,kCAAkC;EAClC,sHAAsH;AACxH","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  overflow-x: hidden;\n  cursor: none;\n\n}\n\nbody::-webkit-scrollbar {\n  display: none;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* import nats font from public folder */\n@font-face {\n  font-family: 'NATS';\n  src: url('../public/NATS-Regular.ttf') format('truetype');\n}\n\n.title-with-sideline {\n  font-family: 'NATS';\n  font-size: 128px;\n  font-weight: 400;\n  color: #ffffff;\n  line-height: 8rem;\n}\n\n.sideline {\n  border-radius: 3px;\n  height: auto;\n}\n\n.sideline.right {\n  margin-left: 3rem;\n}\n\n.sideline.left {\n  margin-right: 3rem;\n}\n\np {\n  margin: 0;\n  font-family: 'NATS';\n  font-size: 22px;\n  font-weight: 400;\n}\n\nh1 {\n  margin: 0;\n  display: block;\n  margin-block-start: 1rem;\n  margin-block-end: 1rem;\n  font-weight: 400;\n  font-size: 128px;\n}\n\nh2 {\n  margin: 0;\n  display: block;\n  margin-block-start: 1rem;\n  margin-block-end: 1rem;\n  font-weight: 400;\n  font-size: 80px;\n}\n\nh3 {\n  font-family: \"NATS\";\n  margin: 0;\n  display: block;\n  margin-block-start: 1rem;\n  margin-block-end: 1rem;\n  font-weight: 400;\n  font-size: 80px;\n}\n\n.navbar {\n  font-family: 'NATS';\n  padding-right: 0.2em;\n  font-size: 40px;\n  font-weight: 400;\n  color: #ffffff;\n}\n\n.navbar.open {\n  height: 100vh;\n  backdrop-filter: blur(10px);\n}\n\n.navbar::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 50%);\n  z-index: -1;\n  opacity: 0;\n  transition: opacity 1.5s ease-in-out;\n}\n\n.sticky::before {\n  opacity: 1;\n  transition: opacity 1.5s ease-in-out;\n}\n\n.sticky {\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 2;\n}\n\n@keyframes float {\n\t0% {\n\t\ttransform: translatey(0px) rotate(-54deg);\n\t}\n\t50% {\n\t\ttransform: translatey(-20px) rotate(-52deg);\n\t}\n\t100% {\n\t\ttransform: translatey(0px) rotate(-54deg);\n\t}\n}\n\n@keyframes cursorAnimation {\n  0% {\n    transform: scale(1) translate(-50%, -50%);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.1) translate(-45%, -45%);\n    opacity: 0.98;\n  }\n  100% {\n    transform: scale(1) translate(-50%, -50%);\n    opacity: 1;\n  }\n}\n\n.customCursor {\n  position: absolute;\n  top: 0; /* Center vertically */\n  left: 0; /* Center horizontally */\n  width: 20px;\n  height: 20px;\n  border-radius: 10px;\n  background-color: rgba(255, 255, 255, 0.5);\n  pointer-events: none;\n  z-index: 1;\n  transition: background-color 0.5s ease-in-out, width 0.5s ease-in-out;\n  transform-origin: center;\n  animation: cursorAnimation 2s infinite;\n}\n\n.customCursor.flat {\n  width: 4px;\n  transform-origin: center;\n  background-color: white;\n  transition: background-color 0.5s ease-in-out, width 0.5s ease-in-out;\n}\n\n\n.spacer {\n  height: 400px;\n}\n\n.text-spacer {\n  padding-top: 13rem;\n}\n\n.project-container {\n  margin-top:  4rem;\n}\n\n@media (max-width: 1199.98px) {\n  .spacer {\n    height: 50px;\n  }\n  .text-spacer {\n    padding-top: 3rem;\n  }\n\n  .project-container {\n    margin-top:  0rem;\n  }\n}\n\n@keyframes cursorAnimation {\n  0% {\n    transform: scale(1) translate(-50%, -50%);\n    opacity: 1;\n  }\n  50% {\n    transform: scale(1.1) translate(-45%, -45%);\n    opacity: 0.98;\n  }\n  100% {\n    transform: scale(1) translate(-50%, -50%);\n    opacity: 1;\n  }\n}\n\n.clip-circle {\n  clip-path: circle(165px at center);\n  transition: clip-path 1s ease-in-out 0.5s, width 1s ease-in-out 1s, height 1s ease-in-out 1s, transform 1s ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
